<template>
  <div class="zyc-screen">
    <label>统计维度：</label>
    <el-select v-model="formData.dimension" style="width:122px;margin-right:10px;" :popper-append-to-body="false" @change="dimensionChange" @clear="cancel">
      <el-option v-for="i in defaultTime" :value="i.value" :label="i.label" :key="i.value"></el-option>
    </el-select>
    <template v-if="datePickerType != 'quarter'">
      <el-date-picker v-model="formData.beginTime"
                      :editable="false"
                      style="margin-right:5px;"
                      :clearable="false"
                      :append-to-body="false"
                      :value-format="valueFormat"
                      :placeholder="datePickerPlaceholder"
                      :type="datePickerType"
                      :picker-options="beginTimeOption"
                      @change="handleBeginValChange">
      </el-date-picker>
      至
      <el-date-picker v-model="formData.endTime"
                      :editable="false"
                      style="margin-left:5px;"
                      :clearable="false"
                      :append-to-body="false"
                      :value-format="valueFormat"
                      :placeholder="datePickerPlaceholder"
                      :type="datePickerType"
                      :picker-options="endTimeOption"
                      @change="handleEndValChange">
      </el-date-picker>
    </template>
    <template v-else-if="datePickerType == 'quarter'">
      <zyc-quarter v-model="formData.beginTime"
                   ref="beginTime"
                   style="margin-right:5px;"
                   :minYear="quarter.beginMinYear"
                   :maxYear="quarter.beginMaxYear"
                   :maxQuarter="quarter.beginMaxQ"
                   :minQuarter="quarter.beginMinQ"
                   :qChange="handleBeginValChange">
      </zyc-quarter>
      至
      <zyc-quarter v-model="formData.endTime"
                   ref="endTime"
                   style="margin-left:5px;"
                   :minYear="quarter.endMinYear"
                   :maxYear="quarter.endMaxYear"
                   :maxQuarter="quarter.endMaxQ"
                   :minQuarter="quarter.endMinQ"
                   :qChange="handleEndValChange">
      </zyc-quarter>
    </template>
    <!--<button class="zyc-screen-but">导出</button>-->
  </div>
</template>

<script>
export default {
  name: "zycScreen",
  props: {
    defaultSel: {
      type: String,
      default: ''
    },
    selChange: {
      type: Function,
      default: () => { }
    },
    valChange: {
      type: Function,
      default: () => { }
    }
  },
  model: {
  },
  watch: {
  },
  data() {
    return {
      formRef: Math.random().toString(36).slice(2),
      formData: {
        dimension: '',
        beginTime: '',
        endTime: ''
      },
      quarter: {
        beginMinYear: 1985,
        beginMaxYear: new Date().getFullYear(),
        endMinYear: 1985,
        endMaxYear: new Date().getFullYear(),
        beginMaxQ: '',
        beginMinQ: '1985-1',
        endMaxQ: '',
        endMinQ: ''
      },
      datePickerType: 'date',
      valueFormat:'yyyy-MM-dd',
      datePickerPlaceholder:'请选择日期',
      defaultTime: [
        {
          label: '以月度单位',
          value: '1'
        },
        {
          label: '以季度单位',
          value: '2'
        },
        {
          label: '以年度单位',
          value: '3'
        }
      ],
      beginTimeOption: {
        disabledDate: (time) => {
          var date = new Date();
          var bdate = new Date('1985-01-01')
          if (this.formData.endTime == '') {
            return time.getTime() > Date.now() - 1 * 24 * 60 * 60 * 1000 || time.getTime() < bdate.getTime();
          } else {
            return time.getTime() > date.getTime() || time.getTime() < bdate.getTime()
          }
        }
      },
      endTimeOption: {
        disabledDate: (time) => {
          var date = new Date(this.formData.beginTime);
          return time.getTime() < date.getTime() || time.getTime() > Date.now() - 1 * 24 * 60 * 60 * 1000
        }
      }
    }
  },
  mounted() {
    this.quarter.beginMaxQ = this.getCurrentQuarter()
  },
  created() {
  },
  methods: {
    dimensionChange: function () {
      switch (this.formData.dimension) {
        case '1':
          this.datePickerType = 'month'
          this.datePickerPlaceholder = '请选择月'
          this.valueFormat = 'yyyy-MM'
          break
        case '2':
          this.datePickerType = 'quarter'
          break
        case '3':
          this.datePickerType = 'year'
          this.datePickerPlaceholder = '请选择年'
          this.valueFormat = 'yyyy'
          break
        default:
          this.datePickerType = 'date'
          this.valueFormat = 'yyyy-MM-dd'
          this.datePickerPlaceholder = '请选择日期'
      }
      this.formData.beginTime = ''
      this.formData.endTime = ''
      this.selChange(this.formData.dimension)
    },
    cancel: function () {
      this.formData.beginTime = ''
      this.formData.endTime = ''
    },
    handleBeginValChange: function (val) {
      console.log(this.datePickerType)
      this.formData.beginTime = val
      this.formData.endTime = ''
      if(this.datePickerType == 'quarter'){
        this.$refs.endTime.setValue('')
      }
      this.quarter.endMinYear = parseInt(val.split('-')[0])
      this.quarter.endMinQ = val
      this.valChange(this.formData.dimension, this.formData.beginTime, this.formData.endTime)
    },
    handleEndValChange: function (val) {
      this.formData.endTime = val
      this.quarter.beginMaxYear = parseInt(val.split('-')[0])
      this.valChange(this.formData.dimension, this.formData.beginTime, this.formData.endTime)
    },
    handleValChange: function (val) {
      this.valChange(this.formData.dimension, this.formData.beginTime, this.formData.endTime)
    },
    selectDimension: function (val) {
      this.formData.dimension = val
      this.dimensionChange(this.formData.dimension)
    },
    setDate: function (begin, end) {
      if (this.formData.dimension === '2') {
        this.$nextTick(() => {
          this.formData.beginTime = begin
          this.formData.endTime = end
          this.quarter.endMinYear = parseInt(begin.split('-')[0])
          this.$refs.beginTime.setValue(begin)
          // this.$refs.endTime.setValue(end)
          if(this.datePickerType == 'quarter'){
            this.$refs.endTime.setValue(end)
          }
          this.quarter.endMaxQ = end
          this.quarter.endMinQ = begin
        })
      } else {
        this.formData.beginTime = begin
        this.formData.endTime = end
      }
    },
    getCurrentQuarter: function () {
      var currentDate = new Date();
      var currentMonth = currentDate.getMonth() + 1; // 月份从0开始，所以要加1

      var currentQuarter;

      if (currentMonth >= 1 && currentMonth <= 3) {
        currentQuarter = 1;
      } else if (currentMonth >= 4 && currentMonth <= 6) {
        currentQuarter = 2;
      } else if (currentMonth >= 7 && currentMonth <= 9) {
        currentQuarter = 3;
      } else {
        currentQuarter = 4;
      }
      return currentDate.getFullYear() + '-' + currentQuarter
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/common/zyc/other/screen.vue